<template>
  <v-container fluid>
    <v-layout flex justify-center row>
      <v-flex xs12 sm10 md8 lg8 xl6>
        <v-stepper
          v-model="e1"
        >
          <v-stepper-header class="elevation-0">
            <template v-for="n in steps">
              <v-stepper-step
                :key="`${n}-step`"
                :complete="e1 > n"
                :step="n"
                color="accent"
              >
                {{setHeader(n)}}
              </v-stepper-step>

              <v-divider
                v-if="n !== steps"
                :key="n"
              ></v-divider>
            </template>
          </v-stepper-header>
          <v-layout class="ml-4 mr-4" justify-space-around row>
            <v-icon class="mr-3" large color="accent">house</v-icon>
            <v-flex column>
              <small>FORMULAR</small>
              <br>
              <h2 class="text-uppercase mb-2">{{ wizardData.name }}</h2>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>
          <v-stepper-items>
            <v-stepper-content
              v-for="n in steps"
              :key="`${n}-content`"
              :step="n"
            >
              <v-card
                class="mb-12 "
              >
                <keep-alive>
                  <StepComponent ref="childComponent" :additionalData="addTemplate"
                                 :stepData="wizardData.steps[n-1]"
                                 :slug="slug"
                                 v-on:emit-data="storeChildData">
                  </StepComponent>
                </keep-alive>
              </v-card>
              <v-layout class="mt-4">
                <v-spacer></v-spacer>
                <v-btn @click="prevStep(n)" text>{{prevOrAbort}}</v-btn>
                <v-btn
                  color="accent"
                  @click="nextStep(n)"
                >
                  {{nextOrSend}}
                </v-btn>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import StepComponent from '~/components/anfragen/wizards/steps/StepComponent'

export default {
  components: {
    StepComponent
  },
  name: 'AnfragenWizardNewComponent',
  props: {
    additionalTemplates: {
      type: Array,
      required: false
    },
    slug: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false
    }
  },
  created() {
    this.load()
  },
  data() {
    return {
      e1: 1,
      formData: {},
      wizardData: {
        name: '',
        steps: [
          {
            header: '',
            order_index: 0
          }
        ]
      }
    }
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    }
  },
  computed: {
    prevOrAbort: function () {
      if (this.e1 === 1) {
        return 'Abbrechen'
      } else return 'Zurück'
    },
    nextOrSend: function () {
      if (this.e1 === this.steps) {
        return 'Senden'
      } else return 'Weiter'
    },
    steps: function () {
      return this.wizardData.steps.length
    },
    addTemplate: function () {
      if (Array.isArray(this.additionTemplate)) {
        for (let additionalTemplate of this.additionalTemplates) {
          if (additionalTemplate.step === this.e1) return additionalTemplate.template
        }
      }
      return ''
    }
  },
  methods: {
    setHeader(n) {
      if (n === 0) return ''
      return this.wizardData.steps[n - 1].header.toUpperCase()
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    nextStep(n) {
      if (this.$refs.childComponent[this.e1 - 1].validate()) {
        if (n === this.steps) {
          this.sendData(this.formData)
        } else {
          this.e1 = n + 1
        }
      }
    },
    prevStep(n) {
      if (n === 1) {
        this.$refs.childComponent[this.e1 - 1].reset()
        this.e1 = 1
      } else {
        this.e1 = n - 1
      }
    },
    storeChildData(data) {
      this.formData = { ...this.formData, ...data }
    },
    async sendData(data) {
      this.$set(this.formData, 'type', this.type)
      this.error = true
      this.busy = true
      try {
        this.error = false
        this.sent = true
        const isSuccess = await this.$store.dispatch('sendAnfrage', data)
        this.busy = false

        this.formData = {}
        this.e1 = 1
        this.load()
      } catch (ex) {
        // console.log(ex)
      }
    },
    load () {
      axios.get('/api/v1/wizard/' + this.slug)
        .then(resp => {
          this.wizardData = resp.data.data
          this.wizardData.steps.sort((x, y) => {
            return x.order_index - y.order_index
          })
        })
        .catch(e => {
          // console.log(e)
        })
    }
  }
}
</script>
